import { Routes } from '@angular/router';
import { routesAdminDadosEmpresa } from './routes_admin_dados_empresa';
import { routesDeposito } from './routes_admin_deposito';
import { routesAdminExpedicao } from './routes_admin_expedicao';
import { routesAdminFinanceiro } from './routes_admin_financeiro';
import { routesAdminMateriaPrima } from './routes_admin_materia_prima';
import { routesAdminParametrizacao } from './routes_admin_parametrizacao';
import { routesAdminParceiro } from './routes_admin_parceiro';
import { routesAdminPedidosProducao } from './routes_admin_pedidos_producao';
import { routesAdminProduto } from './routes_admin_produto';
import { routesAdminVendas } from './routes_admin_vendas';

export const routesAdmin: Routes = [
  ...routesAdminParceiro,
  ...routesAdminParametrizacao,
  ...routesAdminMateriaPrima,
  ...routesAdminProduto,
  ...routesAdminDadosEmpresa,
  ...routesAdminFinanceiro,
  ...routesAdminVendas,
  ...routesAdminPedidosProducao,
  ...routesAdminExpedicao,
  ...routesDeposito
];
